module.exports = __webpack_public_path__ + "static/media/icon_config_launch.2009a8db.svg";